import React from "react";
import * as Icons from "lucide-react";
import { useTranslate } from "../../i18n/useTranslate";

export default function SectionHeader({ icon, title, subtitle, action, badge }) {
  const Icon = Icons[icon] || Icons.LayoutDashboard;
  const t = useTranslate();
  return (
    <div className="flex items-start justify-between mb-6">
      <div className="flex items-start gap-3">
        <div className="w-10 h-10 gov-gradient rounded-2xl flex items-center justify-center shadow-sm flex-shrink-0 mt-0.5">
          <Icon size={18} className="text-[#0A2A5E]" />
        </div>
        <div>
          <div className="flex items-center gap-2">
            <h2 className="section-title">{t(title)}</h2>
            {badge && (
              <span className="text-[10px] font-black bg-red-100 text-red-700 px-2 py-0.5 rounded-full">{t(badge)}</span>
            )}
          </div>
          {subtitle && <p className="section-subtitle">{t(subtitle)}</p>}
        </div>
      </div>
      {action && <div className="flex-shrink-0">{action}</div>}
    </div>
  );
}
